'use strict';

var index = require('../color/index.cjs');
var index$1 = require('../complex/index.cjs');
var dimensions = require('../dimensions.cjs');
var test = require('../test.cjs');

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensions.dimensionValueTypes, index.color, index$1.complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(test.testValueType(v));

exports.findValueType = findValueType;
//# sourceMappingURL=find.cjs.map
